const replacement = '\uFFFD';

const LEGACY_ROLE_ALIASES: Record<string, string> = {
  [`${replacement.repeat(5)} ${replacement.repeat(7)} ${replacement.repeat(6)}`]: 'Керівник',
  [replacement.repeat(7)]: 'Керівник',
  [replacement.repeat(12)]: 'Адміністратор',
  [`${replacement.repeat(3)} ${replacement.repeat(5)}`]: 'Шеф кухар',
  [replacement.repeat(5)]: 'Кухар',
  [replacement.repeat(6)]: 'Посудомийка',
  [replacement.repeat(13)]: 'Прибиральниця',
  [replacement.repeat(8)]: 'Офіціант',
  ШефКухар: 'Шеф кухар',
};

export const normalizeRoleNames = (roles: string[]): string[] => {
  return roles.map((role) => LEGACY_ROLE_ALIASES[role] || role);
};
